import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MailIcon } from 'lucide-react';
import { PROFILE, SECTIONS } from '../data/profile';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-navy-950" data-id="element-128" data-mp="32o4d0g3lai96">
      <div className="mx-auto max-w-content px-6 py-14 lg:px-8" data-id="element-129" data-mp="32lrmhejrmzki">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-130" data-mp="36q92r3qx2uqj">
          <div className="lg:col-span-4" data-id="element-131" data-mp="3uesb1j9yv7im">
            <div className="flex items-center gap-3" data-id="element-132" data-mp="3uftlblj5rpza">
              <img src={PROFILE.portrait} alt="" aria-hidden="true" className="h-12 w-12 border border-gold-500/60 object-cover p-[2px]" data-id="element-133" data-mp="38za4uuqp54h" />
              <span data-id="element-134" data-mp="3qcdp2qb03rn4">
                <span className="block font-serif text-lg text-white" data-id="element-135" data-mp="3qblwlocpaa12">
                  Gerry Holmes, CPA
                </span>
                <span className="mt-1 block text-[10px] uppercase tracking-widest text-slateink-500" data-id="element-136" data-mp="2ey9yzv7jannc">
                  Global Finance Executive
                </span>
              </span>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slateink-300" data-id="element-137" data-mp="3gah29wtj3p7f">
              Board Director and Audit Committee candidate. {PROFILE.location}.
            </p>
            <div className="mt-7 flex items-center gap-3" data-id="element-138" data-mp="3v5deel4gkwps">
              <a href={`mailto:${PROFILE.email}`} aria-label="Email Gerry Holmes" className="flex h-10 w-10 items-center justify-center border border-white/15 text-slateink-300 transition-colors hover:border-gold-500 hover:text-gold-400" data-id="element-139" data-mp="3q7u0xnfl4nyw">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-140" data-mp="hrih5s06by0f" />
              </a>
              <a href={PROFILE.linkedin} target="_blank" rel="noreferrer noopener" aria-label="Gerry Holmes on LinkedIn" className="flex h-10 w-10 items-center justify-center border border-white/15 text-slateink-300 transition-colors hover:border-gold-500 hover:text-gold-400" data-id="element-141" data-mp="cus0b2gjoydy">
                <LinkedinIcon className="h-4 w-4" aria-hidden="true" data-id="element-142" data-mp="ytxzrrcskp3l" />
              </a>
            </div>
          </div>

          <nav aria-label="All sections" className="lg:col-span-8" data-id="element-143" data-mp="13t0sccbl52uo">
            <h2 className="text-[11px] uppercase tracking-widest text-gold-400" data-id="element-144" data-mp="18k0rlo86fx0c">
              All Ten Sections
            </h2>
            <ul className="mt-6 grid grid-cols-1 gap-x-10 gap-y-3 sm:grid-cols-2" data-id="element-145" data-mp="1cmdv05zgbity">
              {SECTIONS.map(section => <li key={section.index} data-id="element-146" data-mp="1hj4bguf64gfw">
                  <Link to={section.to} className="flex items-baseline gap-3 text-[13px] text-slateink-300 transition-colors hover:text-gold-400" data-id="element-147" data-mp="1mk1rp1gmb0er">
                    <span className="font-serif text-[11px] text-slateink-500" data-id="element-148" data-mp="3obey5uy8hgcx">
                      {section.index}
                    </span>
                    {section.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>

        <p className="mt-12 border-t border-white/5 pt-6 text-[12px] text-slateink-500" data-id="element-149" data-mp="25of2ufazseml">
          © {new Date().getFullYear()} Gerry Holmes. {PROFILE.location}. CPA —{' '}
          {PROFILE.cpaLicense}.
        </p>
      </div>
    </footer>;
}